import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Category } from '../../../models/category';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private endpointPrefix = environment.apiUrl;

  constructor(private http: HttpClient) {}
  
  public createCategoryForCustomer(customerId: number, payload: any) {
    return this.http.post(`${this.endpointPrefix}/categories/customer/${customerId}`, payload);
  }

  public getAllCategories(){
    return this.http.get<Category[]>(`${this.endpointPrefix}/categories`);
  }

  public getCategoriesByCustomer(customerId: number) {
    return this.http.get<Category[]>(`${this.endpointPrefix}/categories/customer/${customerId}`);
  }

  public getCategoryById(id: number){
    return this.http.get<Category>(`${this.endpointPrefix}/categories/${id}`);
  }

  public updateCategoryForCustomer(customerId: number, id: number, payload: any) {
    return this.http.patch(`${this.endpointPrefix}/categories/customer/${customerId}/${id}`,payload);
  }

  public deleteCategoryForCustomer(customerId: number, id: number) {
    return this.http.delete(`${this.endpointPrefix}/categories/customer/${customerId}/${id}`);
  }
}
